import { types } from "../../actions/types";

const initialState = {
  message: null,
  error: null,
  loading: false,
  wifiData: null,
};

export default function wifiData(state = initialState, action) {
  switch (action.type) {
    case types.WIFI_DATA_PENDING:
      return {
        ...state,
        loading: true,
      };
    case types.GET_WIFI_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
        wifiData: action.wifiData,
      };

    case types.WIFI_DATA_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
